import initials from 'initials';
export default {
  name: 'SidedarCompanyItem',
  props: {
    companyId: {
      type: String
    },
    name: {
      type: String
    },
    // role: {
    //   type: String,
    // },
    photoUrl: {
      type: [String, null]
    },
    isCurrent: {
      type: Boolean
    }
  },
  computed: {
    isDemo() {
      return this.companyId === process.env.VUE_APP_DEFAULT_COMPANY_ID;
    },
    companyInitials() {
      return initials(this.name).slice(0, 2).toUpperCase();
    }
  }
};